<template>
  <div class="main-content team-form">
    <div>
      <p v-show="!editable && members.length === 0" class="text-muted">
        Team members were not added.
      </p>
      <TeamForm v-if="editable" />

      <div v-if="!editable" class="members">
        <div v-for="member in members" :key="member.image_url" class="member">
          <div class="member-profile">
            <div
              v-if="member.image_url"
              class="member-avatar"
              :style="{
                'background-image': `url(${getTransformedMemberUrl(
                  member.image_url,
                )})`,
              }"
            />
            <div
              v-if="!member.image_url"
              class="member-avatar"
              :style="{
                'background-image': 'url(/static/images/useryellow.jpg)',
              }"
            />
            <div class="member-social">
              <a
                v-show="member.twitter_url"
                :href="normalizeLink(member.twitter_url)"
                target="_blank"
              >
                <i class="ion ion-social-twitter"></i>
              </a>
              <a
                v-show="member.facebook_url"
                :href="normalizeLink(member.facebook_url)"
                target="_blank"
              >
                <i class="ion ion-social-facebook"></i>
              </a>
              <a
                v-show="member.linkedin_url"
                :href="normalizeLink(member.linkedin_url)"
                target="_blank"
              >
                <i class="ion ion-social-linkedin"></i>
              </a>
            </div>
          </div>
          <div class="member-content">
            <h2>{{ member.name }}</h2>
            <p class="member-role">
              {{ member.title }}
            </p>
            <div class="member-about">
              <p v-for="text in getParagraphs(member.bio)" :key="text">
                {{ text }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TeamForm from './TeamForm'
import { mapState } from 'vuex'
import { normalizeLink } from 'utils'
import { cloudinaryTransform } from '@/filters'

export default {
  components: { TeamForm },
  props: {
    editable: { type: Boolean, default: false },
  },
  computed: {
    ...mapState({
      members: (state) => state.startupProfile.startup.members,
    }),
  },
  methods: {
    normalizeLink,
    getParagraphs: function getParagraphs(bio) {
      const viewBio = bio || ''
      return viewBio.split(/\n\n/)
    },
    getTransformedMemberUrl(url) {
      return cloudinaryTransform(url, { w: 256, h: 256, c: 'limit' })
    },
  },
}
</script>

<style scoped lang="scss">
.team-form {
  padding: 18px 17px;

  .member-avatar {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 128px;
    height: 128px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    border: none;
  }
}

.section-header {
  margin: 24px 0 36px;
}
</style>
